module.exports = __webpack_public_path__ + "static/media/primary-logo-400X115.2cd5c1d1.svg";